import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import { comics, categories, featuredComicIds, latestUpdateIds } from '@/mocks/comics';

const featuredComics = featuredComicIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);
const latestComics = latestUpdateIds.map((id) => comics.find((c) => c.id === id)!).filter(Boolean);

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '歪歪漫画网 - 首页',
          description: '歪歪漫画网提供歪歪漫画在线免费观看与在线阅读服务，囊括海量好看漫画全集，支持下拉式模式随时随地免费看韩漫日漫国漫。',
          url: 'https://www.waiwaimanhua.com',
          isPartOf: {
            '@type': 'WebSite',
            name: '歪歪漫画网',
            url: 'https://www.waiwaimanhua.com',
          },
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.waiwaimanhua.com' },
          ],
        }}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20illustration%20with%20flowing%20curves%20and%20gradients%2C%20manga%20and%20comic%20inspired%20vibrant%20color%20palette%2C%20soft%20orange%20coral%20and%20cream%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20minimalist%20composition%20with%20subtle%20texture%2C%20warm%20and%20inviting%20feeling%2C%20no%20text%20no%20characters%2C%20clean%20smooth%20gradient%20background&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
            alt="歪歪漫画网 - 歪歪漫画在线免费观看"
            title="歪歪漫画在线免费观看"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <div className="w-full max-w-4xl">
              <h1 className="text-2xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
                歪歪漫画在线免费观看
              </h1>
              <p className="text-sm md:text-lg text-background-200 max-w-2xl mx-auto leading-relaxed">
                海量韩漫、日漫、国漫免费看全集，支持下拉式阅读模式，随时随地畅享漫画世界
              </p>
              <div className="flex items-center justify-center gap-3 mt-8 flex-wrap">
                <Link
                  to="/category/hanman"
                  className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  韩漫免费看
                </Link>
                <Link
                  to="/category/riman"
                  className="px-5 py-2.5 bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer"
                >
                  日漫在线
                </Link>
                <Link
                  to="/category/guoman"
                  className="px-5 py-2.5 bg-background-50/20 text-background-50 backdrop-blur-sm rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors border border-background-50/30 whitespace-nowrap cursor-pointer"
                >
                  国漫大全
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-3">
          <Breadcrumb items={[{ label: '首页' }]} />
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-10">
          <div className="flex items-end justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">精选热门漫画，大家都在看</p>
            </div>
            <Link
              to="/category/all"
              className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {featuredComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-14">
          <div className="flex items-end justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                漫画分类
              </h2>
              <p className="text-sm text-foreground-500 mt-1">按类别浏览你喜欢的漫画</p>
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {categories.filter((c) => c.slug !== 'all').map((cat) => {
              const count = comics.filter((c) => c.categorySlug === cat.slug || cat.slug === 'scroll').length;
              return (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group relative h-40 md:h-48 rounded-lg overflow-hidden cursor-pointer"
                >
                  <div className="absolute inset-0 bg-gradient-to-br from-primary-100 via-accent-100/50 to-secondary-100"></div>
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                    <span className="text-2xl md:text-3xl font-heading font-bold text-primary-700 mb-1">
                      {cat.name}
                    </span>
                    <span className="text-xs text-foreground-500">{count}+ 部作品</span>
                    <span className="mt-2 text-xs text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                      立即浏览 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 mt-14 mb-14">
          <div className="flex items-end justify-between mb-6">
            <div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                最近更新
              </h2>
              <p className="text-sm text-foreground-500 mt-1">追更漫画，不错过每一话</p>
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
            {latestComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </section>

        <section className="bg-background-100 py-14">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
                为什么选择歪歪漫画网？
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                歪歪漫画在线免费观看与阅读的最佳选择
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {[
                {
                  icon: 'ri-book-open-line',
                  title: '海量漫画资源',
                  desc: '囊括韩漫、日漫、国漫等各类漫画，免费漫画全集随时看',
                },
                {
                  icon: 'ri-smartphone-line',
                  title: '下拉式阅读',
                  desc: '支持下拉式漫画阅读模式，流畅舒适的阅读体验',
                },
                {
                  icon: 'ri-timer-flash-line',
                  title: '每日更新',
                  desc: '歪歪漫画每日追更，最新的漫画章节第一时间上线',
                },
                {
                  icon: 'ri-shield-check-line',
                  title: '高清画质',
                  desc: '全站漫画高清画质呈现，享受最佳视觉体验',
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="text-center p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                    <i className={`${item.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}